/**
 * Error thrown by the API layer, carrying the HTTP status alongside the
 * message.
 *
 * Lives in its own dependency-free leaf module so it never participates in an
 * import cycle. `useApiQuery` (the throw site) → `useQueryErrorEffect` →
 * `utils/Helper` → `useApiQuery` is a real cycle; when `ResponseError` was
 * defined inside `useQueryErrorEffect`, its binding could resolve to
 * `undefined` at call time (most visibly under the vitest SSR transform:
 * "ResponseError is not a constructor"), which would silently break every
 * `instanceof ResponseError` / `.status` check that auth recovery relies on.
 * A leaf module is always fully initialised before any consumer runs.
 */
export class ResponseError extends Error {
  status?: number;
  /**
   * A plain-text response body, kept apart from `message` so that only
   * callers that know the endpoint's refusal copy is fit to show read it.
   */
  body?: string;

  constructor(message: string, status?: number, body?: string) {
    super(message);
    this.status = status;
    this.body = body;
  }
}
